import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import Registration from './pages/Registration';
import Events from './pages/Events';
import LiveUpdates from './pages/LiveUpdates';
import Gallery from './pages/Gallery';
import Spotlight from './pages/Spotlight';
import FAQs from './pages/FAQs';
import AdminPanel from './pages/AdminPanel';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/registration" element={<Registration />} />
        <Route path="/events" element={<Events />} />
        <Route path="/live-updates" element={<LiveUpdates />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/spotlight" element={<Spotlight />} />
        <Route path="/faqs" element={<FAQs />} />
        <Route path="/admin" element={<AdminPanel />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;